import * as t from "io-ts";
import * as ListingStatus1 from "./ListingStatus1";

export const codec = t.type({
    status: ListingStatus1.codec,
    count: t.number,
});

export type T = t.TypeOf<typeof codec>;
